export default function () {
	const INTEGRATED_FIN = 'fin integrated'
	const CSRD_FIN = 'fin CSRD'
	const CSRD_SUSTY = 'susty CSRD'

	const metaToBaseTypeMapping = {
		fin: { is_integrated: false, is_csrd: false, document_type: 'fin' },
		[INTEGRATED_FIN]: { is_integrated: true, document_type: 'fin' },
		[CSRD_FIN]: { is_csrd: true, document_type: 'fin' },

		susty: { is_csrd: false, is_integrated: false, document_type: 'susty' },
		[CSRD_SUSTY]: { is_csrd: true, document_type: 'susty' },

		'10k': { document_type: '10k' }
	}

	function getBaseToMetaTypeMapping(document_type, is_csrd, is_integrated) {
		if (document_type === 'fin' && is_integrated) {
			return INTEGRATED_FIN
		}
		if (is_csrd) {
			return document_type === 'fin' ? CSRD_FIN : CSRD_SUSTY
		}
		return document_type
	}

	function getReportFlagsToAppend(docType) {
		const flags = {
			is_csrd: false,
			is_integrated: false
		}
		if (docType === INTEGRATED_FIN) {
			flags.is_integrated = true
		} else if ([CSRD_FIN, CSRD_SUSTY].includes(docType)) {
			flags.is_csrd = true
		}
		return flags
	}

	function getReportTypes(reportType) {
		const allTypes = ['fin', INTEGRATED_FIN, CSRD_FIN, 'susty', CSRD_SUSTY, '10k']
		if (reportType) {
			return allTypes.filter((type) => type.startsWith(reportType.split(' ')[0]))
		}
		return allTypes
	}

	function getMappedDocumentType(key) {
		const documentTypeMapping = { fin: 'Financial', susty: 'Sustainability' }
		return documentTypeMapping[key] || key
	}

	return {
		metaToBaseTypeMapping,
		getBaseToMetaTypeMapping,
		getReportFlagsToAppend,
		getReportTypes,
		getMappedDocumentType
	}
}
